/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsTriggerSchedule } from "../../funcs/llmEvalsTriggerSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.TriggerEvalScheduleRequest$inboundSchema,
};

export const tool$llmEvalsTriggerSchedule: ToolDefinition<typeof args> = {
  name: "llm-evals-trigger-schedule",
  description: `Trigger an eval schedule now

Fires the schedule immediately, in addition to its normal cadence.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsTriggerSchedule(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
